import { useQuery } from '@tanstack/react-query';
import { endpoints, ID } from '@rossum/api-client';
import { useApiClient } from '../../../lib/apiClient';

export const QUERY_KEY_QUEUE = 'queues';

export const useQueue = (id: ID | undefined) => {
  const api = useApiClient();
  return useQuery({
    queryKey: [QUERY_KEY_QUEUE, id] as const,
    queryFn: () => api.request(endpoints.queues.get(id ?? 0)),
    enabled: !!id,
  });
};
